












import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { WordSearchPuzzle } from '@/wordsearch/types';

const puzzle = namespace('Puzzle');

@Component
export default class PrintWordList extends Vue {
  @puzzle.State
  private puzzle!: WordSearchPuzzle;

  @puzzle.State
  private gridSize!: number;

  get wordListStyle() {
    return `max-width: ${this.gridSize}px`;
  }
}
